import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Compatibilidade: rotas antigas /equipes/:slugOrId redirecionam para /times/:slugOrId.
 * Mantém qualquer link antigo (UUID ou slug) funcionando após a renomeação.
 */
export default function TeamRedirect({ editar = false }: { editar?: boolean }) {
  const { slugOrId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!slugOrId) {
      navigate('/times', { replace: true });
      return;
    }
    const target = editar ? `/times/${slugOrId}/editar` : `/times/${slugOrId}`;
    navigate(target, { replace: true });
  }, [slugOrId, editar, navigate]);

  return null;
}
